import type {AgentChangeHandler, AgentOverrideRow} from '../../ai-chat-super-user-options.types';

export interface SuperUserPromptVariantsProps {
  agents: AgentOverrideRow[];
  onChangeAgent: AgentChangeHandler;
}

export const WEIGHTED_PICK_VALUE = '';
